import { createSlice } from "@reduxjs/toolkit"

import { stateEnum } from "../constants/enum.js"

const { stock } = stateEnum

const initialState = {
}

const stockSlice = createSlice({
  name: stock,
  initialState,
  reducers: {
    resetStock: (state) => {
    },
    
  },
})

export const { resetStock } = stockSlice.actions
export default stockSlice.reducer
